import React, { useState, useEffect } from "react"
import {
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
} from "reactstrap"
import { DebounceInputSearch, UFDate, UFInput } from "../../../components/Common/Fields/Input"
import Status from "../../../components/Common/chooseFields/status"
import { useForm } from "react-hook-form"
import { Form } from "reactstrap"
import exportIcon from "../../../assets/icons/export.svg"
import {
  importFileData,
  sampleFileDownload,
} from "../../../services/Inventory/inventory"
import closeIcon from "../../../assets/icons/close.svg"
import uploadicon from "../../../assets/icons/import.svg"
import Country from "../../../components/Common/chooseFields/country"
import { toastError, toastSuccess } from "../../../helpers/msg_helper"
import LoadingButton from "../../../components/Common/LoadingButton"
import GRNno from "../../../components/Common/chooseFields/grnno"
import { isEmpty } from "lodash"
import moment from "moment"
import PurchaseNo from "../../../components/Common/chooseFields/purchaseNo"
import ProjectNo from "../../../components/Common/chooseFields/projectno"
import resetIcon from "../../../assets/icons/reset.svg"
import { useSelector } from "react-redux"

const GRNFilter = ({
  handleSearchChange,
  handleGrnChange,
  handleDateChange,
  handlePurchaseChange,
  handleProjectChange,
  handleFinacialChange,
  handleCompanyChange,
  sampleUrl,
  importUrl,
  isImport,
}) => {
  const loggedUser = useSelector(state => state.Login.loggedUser)

  const [modal, setModal] = useState(false)
  const [finacialCheck, setfinacialCheck] = useState(true)
  const [companyCheck, setCompanyCheck] = useState(false)
  const { control, watch, reset } = useForm()

  const toggle = () => {
    setModal(!modal)
    setFile()
    setFileName()
  }

  const handlegrnno = data => {
    handleGrnChange(data?.label)
  }
  const handlepurchaseno = data => {
    handlePurchaseChange(data?.label)
  }
  const handleprojectno = data => {
    handleProjectChange(data?.label)
  }

  const handleSampleFile = () => {
    const handleCommonExport = async () => {
      const response = await sampleFileDownload(sampleUrl)
    }
    handleCommonExport()
  }

  useEffect(() => {
    handleSearchChange(watch("search"))
  }, [watch("search")])

  const [file, setFile] = useState()
  const [fileName, setFileName] = useState()

  const onFileChange = event => {
    setFileName(event)
    setFile(event?.target?.files?.[0])
  }

  const handleRequestdate = data => {
    console.log(data, "data")
    let fromDate = ""
    let toDate = ""
    fromDate = !isEmpty(data) ? moment(data[0]).format("YYYY-MM-DD") : ""
    toDate = !isEmpty(data) ? moment(data[1]).format("YYYY-MM-DD") : ""
    console.log(fromDate, toDate, "toDate")
    handleDateChange(fromDate, toDate)
  }
  const handleImport = () => {
    const importFile = async () => {
      try {
        const response = await importFileData({
          importfile: file,
          url: importUrl,
        })
        toastSuccess(response?.message)
        setModal(false)
      } catch (err) {
        toastError(err?.message)
      }
    }
    importFile()
  }
  const handleReset = () => {
    handleSearchChange()
    handleGrnChange()
    handleDateChange()
    handlePurchaseChange()
    handleProjectChange()
    handleFinacialChange(true)
    handleCompanyChange(false)
    setfinacialCheck(true)
    reset({
      grn_id: null,
      po_no: null,
      project_no: null,
      grn_date: null,
    })
  }

  const handleFinacialCheck = dt => {
    handleFinacialChange(!dt)
    setfinacialCheck(!dt)
  }

  const handleCompanyCheck = dt => {
    handleCompanyChange(!dt)
    setCompanyCheck(!dt)
  }

  return (
    <>
      <div className="d-flex justify-content-between align-items-center my-2 me-2">
        <Form id="user-form" className="filter-wrapper">
          <Row className="mx-0">
            <Col sm={2} className="pe-1">
              <GRNno
                control={control}
                name={"grn_id"}
                placeholder={"Grn no"}
                target={"body"}
                onSelectChange={e => handlegrnno(e)}
              />
            </Col>
            <Col sm={2} className="pe-1">
              <PurchaseNo
                control={control}
                name={"po_no"}
                placeholder={"PO No"}
                target={"body"}
                onSelectChange={e => handlepurchaseno(e)}
              />
            </Col>
            {!companyCheck && (
              <Col sm={2} className="pe-1">
                <ProjectNo
                  control={control}
                  name={"project_no"}
                  placeholder={"P Code"}
                  target={"body"}
                  onSelectChange={e => handleprojectno(e)}
                />
              </Col>
            )}
            <Col sm={2} className="pe-1">
              <UFDate
                control={control}
                placeholder="GRN Date "
                name={"grn_date"}
                mode="range"
                onDateChange={e => handleRequestdate(e)}
              />
            </Col>
          </Row>
        </Form>
        <div className="d-flex">
          <Col
            lg={"auto"}
            onClick={() => handleCompanyCheck(companyCheck)}
            className=" d-flex align-items-center pe-3"
          >
            <input
              type="checkbox"
              className="ever-rise-checkbox"
              name={"is_finacial_year"}
              checked={companyCheck}
            />
            <Label className="ms-2 mb-0">Company</Label>
          </Col>
          {/* <Col
            lg={"auto"}
            onClick={() => handleFinacialCheck(finacialCheck)}
            className=" d-flex align-items-center"
          >
            <input
              type="checkbox"
              className="ever-rise-checkbox"
              name={"is_finacial_year"}
              checked={finacialCheck}
            />
            <Label className="ms-2 mb-0">
              FY {loggedUser?.finance?.replace(/\//g, "")}
            </Label>
          </Col> */}
          <div
            className="export-div pointer me-2 reset-img"
            onClick={() => handleReset()}
          >
            <img src={resetIcon} height={15} width={15} className="me-2" />{" "}
            Reset
          </div>
          <DebounceInputSearch
            control={control}
            placeholder={"Search"}
            name={"search"}
            className={"search-input"}
            minLength={1}
            debounceTimeout={700}
          />
          {/* <UFInput
            control={control}
            placeholder="Search"
            name={"search"}
            className={"search-input"}
          /> */}
          {isImport && (
            <div className="export-div pointer" onClick={() => toggle()}>
              <img src={exportIcon} />
            </div>
          )}
        </div>
      </div>
      <Modal isOpen={modal} toggle={toggle} backdrop={"static"}>
        <ModalHeader className="custom-modal-header">
          <div className="d-flex justify-content-between">
            <h5>{"Bulk Upload"}</h5>
            <img
              src={closeIcon}
              alt=""
              onClick={() => setModal(false)}
              width="10"
              role="button"
            />
          </div>
        </ModalHeader>

        <ModalBody>
          <div className="d-flex p-5 my-3">
            <Col className="file-import-div me-3 ">
              <label htmlFor="upload" className="m-0 pointer">
                <input
                  type="file"
                  id="upload"
                  name="upload"
                  accept=".xls,.xlsx"
                  onChange={event => {
                    onFileChange(event)
                  }}
                />
                {fileName ? (
                  <span>{fileName?.target?.files?.[0]?.name}</span>
                ) : (
                  <>
                    <img
                      src={uploadicon}
                      alt="Upload Excel"
                      className="upload-icon me-2 "
                    />
                    <span className="upload">Upload&nbsp;</span>
                    <span>the file</span>
                  </>
                )}
              </label>
            </Col>
            <button
              className="btn btn-primary"
              type="submit"
              onClick={handleImport}
            >
              Import
            </button>
          </div>
        </ModalBody>
        <ModalFooter className="bulk-upload-footer">
          <Row className="d-flex justify-content-center">
            <Col lg={8} className="text-center">
              Please download the sample file, add items, price etc & upload it
              back to create your Documents
            </Col>
          </Row>
          <Row
            className="fw-bold d-flex justify-content-center w-100 pointer"
            onClick={() => handleSampleFile()}
          >
            Download Sample File &gt;
          </Row>
        </ModalFooter>
      </Modal>
    </>
  )
}

export default GRNFilter
